import axios from "axios";
import Config from "src/config";

const v2_actionAgentsPredictions = (agentId, data) => {
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/ai/agentes/prediction/playground?agent_id=${agentId}`,
        data
        });
};

export default v2_actionAgentsPredictions;
